import { Link } from "react-router-dom";

function SellerDashboard() {
  return (
    <div className="container mt-4">

      <h3>Seller Dashboard</h3>

      <div className="row mt-4">
        <div className="col-md-4">
          <div className="card p-4 text-center">
            <h5>Add Category</h5>
            <Link to="/seller/add-category" className="btn btn-danger">
              Go
            </Link>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card p-4 text-center">
            <h5>Add Product</h5>
            <Link to="/seller/add-product" className="btn btn-primary">
              Go
            </Link>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card p-4 text-center">
            <h5>My Products</h5>
            <Link to="/seller/products" className="btn btn-success">
              Go
            </Link>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card p-4 text-center">
            <h5>My Orders</h5>
           <Link to="/seller/orders" className="btn btn-warning">Orders</Link>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card p-4 text-center">
            <h5>Assign Delivery</h5>
           <Link to="/seller/delivery" className="btn btn-success">Delivery</Link>
          </div>
        </div>
      </div>

    </div>
  );
}

export default SellerDashboard;
